// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiBudgetRoute } from "../apiSlices";

// interfaces.
import { ModelError } from "../interfaces/interfaces";
import {
  CreateRuleBody,
  RawRuleItem,
} from "./interfaces/rawRules.interfaces";

interface CreateRuleApiResponse {
  success: boolean;
  data: RawRuleItem;
  message: string;
}

export const createRuleEndpoints = apiBudgetRoute.injectEndpoints({
  endpoints: (builder) => ({
    createRule: builder.mutation<RawRuleItem, CreateRuleBody>({
      query: (body) => ({
        url: "/rules",
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, body) => [{ type: "Rules", id: body.schema }],
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "createRule",
        };
        return modelError;
      },
      transformResponse: (raw: CreateRuleApiResponse) => raw.data,
    }),
  }),
});

export const { useCreateRuleMutation } = createRuleEndpoints;
